export const GrowthOSWordmark = ({ className = "text-2xl" }) => (
  <span className={`font-display font-extrabold leading-none tracking-tight ${className}`}>
    <span className="gx-wordmark">Growth</span>
    <span className="gx-wordmark-accent">OS</span>
  </span>
);
